import emailjs from '@emailjs/browser'
import React, { useEffect, useState } from 'react';
import './ContactMe.css';
import Textfield, { TextfieldPhone } from './Components/Textfield';
import Button from '../../Components/Button/Button';
import Checkbox from './Components/Checkbox';
import { instagram, whatsapp } from '../../Helper/svgs';
import CardsList from './Components/CardsList';
import SectionIds from '../../Helper/SectionId';
import { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import goToLink from '../../Helper/GoToLink';
import GoToLinks from '../../Data/GoToLinks';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';
const checkboxOptions = [
  'Stocks',
  'PMS',
  'Commodities',
  'Currency',
  'IPOs',
  'Mutual Funds',
  'Others'
];


export default function ContactMe() {

  const [state, setState] = useState({
    fname: '',
    lname: '',
    email: '',
    phone: '',
    checkbox: [],
    errors: {
      fname: '',
      lname: '',
      email: '',
      phone: '',
    },
    isPhoneValid: false
  });

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);


  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.reset();
    let isValid = validateFields();

    if (isValid) {
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      try {
        setIsLoading(true);
        await emailjs.send(serviceId, templateId, {
          f_name: state.fname,
          l_name: state.lname,
          email: state.email,
          phone: state.phone,
          services: state.checkbox,
        });

        setState({
          fname: '',
          lname: '',
          email: '',
          phone: '',
          checkbox: [],
          errors: {
            fname: '',
            lname: '',
            email: '',
            phone: '',

          },
          isPhoneValid: false,
        })
      } finally {
        setIsLoading(false);
      }
    }
  };


  const validateFields = () => {
    let isValid = true;
    const errors = {};

    // Validate First Name
    if (!state.fname.match(/^[A-Za-z]+$/)) {
      errors.fname = 'Symbols and numbers are not allowed';
      isValid = false;
    }

    // Validate Last Name
    if (!state.lname.match(/^[A-Za-z]+$/)) {
      errors.lname = 'Symbols and numbers are not allowed';
      isValid = false;
    }

    // Validate Email
    if (!state.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      errors.email = 'Enter a valid email';
      isValid = false;
    }

    // Validate Phone Number
    if (!state.isPhoneValid) {

      errors.phone = 'Please enter a valid Phone Number';
      isValid = false;
    }
    setState((prevState) => ({ ...prevState, errors }));
    setIsSubmitDisabled(!isValid);
    return isValid;
  };
  useEffect(() => {
    const disableSubmit = () => {

      let isValid = true;

      // Check if fields are initialized or empty strings
      const { fname, lname, email, phone } = state;

      if (!fname || !lname || !email || !phone) {
        isValid = false;
      }

      if (fname && !fname.match(/^[A-Za-z]+$/)) {
        isValid = false;
      }

      // Validate Last Name
      if (lname && !lname.match(/^[A-Za-z]+$/)) {
        isValid = false;
      }

      // Validate Email
      if (email &&!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        isValid = false;
      }

      // Validate Phone Number
      if (!state.isPhoneValid) {

        isValid = false;
      }

      setIsSubmitDisabled(!isValid);


    }
    disableSubmit();
  }, [state]);

  const handleFNameChange = (event) => {
    const value = event.target.value.trim();
    var error = value !== ''
      ? value.match(/^[A-Za-z]+$/)
        ? ''
        : 'Symbols and numbers are not allowed'
      : ''
    setState((prevState) => ({
      ...prevState,
      fname: value,
      errors: {
        ...prevState.errors,
        fname: error,
      },
    }));
  };

  const handleLNameChange = (event) => {
    const value = event.target.value.trim();
    var error = value !== ''
      ? value.match(/^[A-Za-z]+$/)
        ? ''
        : 'Symbols and numbers are not allowed'
      : ''
    setState((prevState) => ({
      ...prevState,
      lname: value,
      errors: {
        ...prevState.errors,
        lname: error
      },
    }));
  };


  const handlePhoneChange = (value) => {
    let valid = value ? isPossiblePhoneNumber(value) : false;

    setState((prevState) => ({
      ...prevState,
      phone: value,
      errors: {
        ...prevState.errors,
        phone: valid ? '' : prevState.errors.phone
      },
      isPhoneValid: valid
    }));



  }
  const handlePhoneBlur = (event) => {
    // const value = event.target.value;

    setState((prevState) => ({

      ...prevState,
      errors: {
        ...prevState.errors,
        phone: state.isPhoneValid ? '' : 'Please enter a valid Phone Number',
      },
    }));
  };

  const handleCheckboxes = (event) => {
    const { value, checked } = event.target;

    setState((prevState) => ({
      ...prevState,
      checkbox: checked ? [...prevState.checkbox, value] : prevState.checkbox.filter((item) => item !== value),
    }));
  };
  const handleEmailChange = (event) => {
    const value = event.target.value.trim();
    setState((prevState) => ({
      ...prevState,
      email: value,
      errors: {
        ...prevState.errors,
        email: value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) ? '' : prevState.errors.email
      }
    }));
  };
  const handleEmailBlur = (event) => {
    const value = event.target.value;

    var error = value.trim() !== '' ?
      (
        value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
          ? ''
          : 'Enter a valid email'
      )
      : ''
    setState((prevState) => ({
      ...prevState,
      email: value,
      errors: {
        ...prevState.errors,
        email: error,
      },
    }));
  };

  return (
    <SectionWithAnalytics className='section section-contactme' id={SectionIds.sectionContactMe}>
      <div className='form-wrapper'>
        <form onSubmit={handleSubmit} className='form container-vertical'>
          <div className='textfields res-gap-8'>
            <div className='row res-gap-8'>
              <Textfield
                id='tf-fname'
                label='First Name'
                value={state.fname}
                onChange={handleFNameChange}
                error={state.errors.fname}
              />
              <Textfield
                id='tf-lname'
                label='Last Name'
                value={state.lname}
                onChange={handleLNameChange}
                error={state.errors.lname}
              />
            </div>
            <Textfield
              id='tf-email'
              label='Email'
              value={state.email}
              onChange={handleEmailChange} // Check error onBlur
              onBlur={handleEmailBlur}
              error={state.errors.email}
            />
            <TextfieldPhone
              id='tf-phone'
              label='Phone Number'
              value={state.phone}
              onChange={handlePhoneChange} // Check error onChange
              onBlur={handlePhoneBlur}
              error={state.errors.phone}
              onCountryChange={(code) => {
              }}
            />
          </div>
          <div className='checkboxes-container container-vertical res-gap-8'>
            <div className='checkboxes-label'>Services</div>
            <div className='checkboxes'>
              {checkboxOptions.map((element, index) => (
                <Checkbox
                  key={`cb-${index}`}
                  id={`cb-${index}`}
                  label={element}
                  value={element}
                  onChange={handleCheckboxes}
                />
              ))}
            </div>
          </div>
          <Button name='Submit' disabled={isSubmitDisabled} isLoading={isLoading} />
        </form>
      </div>
      <div className='header container-vertical res-gap-8'>
        <h3 className='text-align-left'>
          <mark>Contact</mark> Me
        </h3>
        <div className='text-align-left fs-medium clr-grey-600 fw-regular'>
          Have a Doubt? Feel free to ask.
        </div>
      </div>
      <div className='contact-info container-vertical res-gap-32'>
        {<CardsList />}
        <div className='container-horizontal res-gap-8 align-center'>
          <Button
            icon={whatsapp()}
            name='Chat with us'
            onClick={() => goToLink(GoToLinks.whatsappLink)}
          />
          <Button
            icon={instagram()}
            style={{
              height: 'auto',
              // aspectRatio: '1'
            }}
            onClick={() => goToLink(GoToLinks.instagramLink)}
          />
        </div>
      </div>
    </SectionWithAnalytics>
  );
}
